import {useSearchParams} from "react-router-dom";

function useUrlQueryState(key: string, defaultValue: string): [string, (value?: string) => void] {
    const [searchParams, setSearchParams] = useSearchParams();

    const searchParamValue = searchParams.get(key);

    const setUrlState = (value?: string) => {
        setSearchParams(params => {
            if (value) {
                params.set(key, value);
            } else {
                params.delete(key);
            }
            return params;
        });
    }

    return [searchParamValue ?? defaultValue, setUrlState];
}

export default useUrlQueryState;